<div class="shadow-box">
  <img data-src="/assets/images/team/bird-logo.png" />
  <div class="title">Work With Ketto</div>
  <div class="subtitle">
    Everyday, we strive to make this world a better place.
    Our commitment towards bringing a change drives us and
    if you share our passion, come join us.</div>
    <a href="https://ketto.kekahire.com/" target="_blank" class="find-job-cta" mat-raised-button>EXPLORE OPPORTUNITIES</a>
</div>
